import {Form, Input, Checkbox} from 'antd';
import {xor} from 'lodash-es';
import React, {FC} from 'react';

import {CustomSelect, ECustomSelectMode} from 'components/form/inputs/custom-select';
import {IGroupHoldingInfoListLitem} from 'pages/ais/organization-structure-v5/model/types';

import styles from './group-holding-info-list-item.module.less';

export const GroupHoldingInfoListLitem: FC<IGroupHoldingInfoListLitem> = ({
    setSelectedRows,
    selectedRows,
    field,
}: IGroupHoldingInfoListLitem) => (
    <article
        key={field.name}
        className="d-flex gap-2"
    >
        <Form.Item
            className="mt-3"
            label={<>&nbsp;</>}
        >
            <Checkbox
                checked={selectedRows.includes(field.name)}
                onClick={() => setSelectedRows(xor(selectedRows, [field.name]))}
            />
        </Form.Item>
        <div>
            <div className="d-flex gap-2">
                <div className="d-flex gap-2 align-items-end">
                    <Form.Item
                        label="Код группы компаний (холдинга)"
                        rules={[
                            {required: true},
                            {pattern: /^\d{1,3}$/, message: 'Количество цифр должно быть от 1 до 3'},
                        ]}
                        validateTrigger="onBlur"
                        name={[field.name, 'groupCode']}
                        className={styles['group-holding-info-list-item__group-code--width']}
                    >
                        <Input
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={[{required: true, message: 'Пожалуйста, Признак принадлежности организации'}]}
                        label="Признак принадлежности организации к головной организации группы компаний"
                        name={[field.name, 'position']}
                        className={styles['group-holding-info-list-item__position--width']}
                    >
                        <CustomSelect
                            settings={{
                                url: 'valueLists/FLEX_VALUE?sublistCode=position',
                                valuePath: 'id',
                                labelPath: 'description',
                            }}
                        />
                    </Form.Item>
                </div>
            </div>
            <Form.Item
                rules={[{required: true}]}
                label="Признак взаимозависимости к головной организации группы компаний (холдинга) в соответствии с п.2 ст.105.1 НК РФ"
                name={[field.name, 'cqInterdependence']}
                className="w-100"
            >
                <CustomSelect
                    settings={{
                        mode: ECustomSelectMode.multiple,
                        showSearch: true,
                        url: '/ais/valueLists/FLEX_VALUE?sublistCode=cg_interdependence',
                        valuePath: 'id',
                        labelPath: 'description',
                    }}
                />
            </Form.Item>
        </div>
    </article>
);
